import { axiosCore } from './http-core-service';
import { MovingInDto } from './dtos/moving-in-dto';

/**
 * Service Contactez-nous
 * @return si valide
 */
export const movingInService = async (data: MovingInDto): Promise<string> => {
    const response = await axiosCore.post('/demandes/emmenagement', data);
    return response.data;
};
